import { useCallback, useSyncExternalStore } from "react";

/** UX-01 Rev 3.2 list + drawer breakpoints; docked from 1920 px since the Board shares the drawer (decision 2 Oct 2026). */
export const DOCKED_FROM = 1920;
export const DOCKED_QUERY = `(min-width: ${DOCKED_FROM}px)`;
/** Batch 19 GRF-60 (UX-B19 §1.4): the item lists dock their preview from 1280 px; the Board keeps 1920. */
export const LIST_DOCKED_FROM = 1280;
export const PHONE_QUERY = "(max-width: 759px)";

function supported(): boolean {
  return typeof window !== "undefined" && typeof window.matchMedia === "function";
}

/** Live media-query match. Without matchMedia (tests) every query is false. */
export function useMediaQuery(query: string): boolean {
  const subscribe = useCallback(
    (onChange: () => void) => {
      if (!supported()) return () => undefined;
      const list = window.matchMedia(query);
      list.addEventListener("change", onChange);
      return () => list.removeEventListener("change", onChange);
    },
    [query],
  );
  return useSyncExternalStore(
    subscribe,
    () => (supported() ? window.matchMedia(query).matches : false),
    () => false,
  );
}
